angular.module('elogbooksServices').service('validationService', function($rootScope, $state) {
    this.isFileNameValid = filename => {
        if (/[\/]/.test(filename)) {
            return false;
        }

        return true;
    };

    // Maximum size of a file that can be uploaded, in bytes (2GB)
    this.MAX_FILE_SIZE = 2147483648;

    this.isFileSizeValid = size => typeof size === 'number' && size <= this.MAX_FILE_SIZE;

    this.exitFormWithNoDirtyCheck = (goTo, reload = false) => {
      $rootScope.skipDirtyCheck = true;

      const reloadData = reload ? {reload: reload} : {};

      $state.go(goTo, {}, reloadData).then(() => {
         $rootScope.skipDirtyCheck = false;
      });
    };

    return this;
});
